export const SMVM_SET_ANSWER_ASSESSEE_REQUEST =
  "SMVM_SET_ANSWER_ASSESSEE_REQUEST";
export const SMVM_SET_ANSWER_ASSESSEE_SUCCESS =
  "SMVM_SET_ANSWER_ASSESSEE_SUCCESS";
export const SMVM_SET_ANSWER_ASSESSEE_FAIL = "SMVM_SET_ANSWER_ASSESSEE_FAIL";
export const SMVM_SET_ANSWER_ASSESSEE_RESET = "SMVM_SET_ANSWER_ASSESSEE_RESET";

export const SMVM_GET_ANSWER_ASSESSEE_REQUEST =
  "SMVM_GET_ANSWER_ASSESSEE_REQUEST";
export const SMVM_GET_ANSWER_ASSESSEE_SUCCESS =
  "SMVM_GET_ANSWER_ASSESSEE_SUCCESS";
export const SMVM_GET_ANSWER_ASSESSEE_FAIL = "SMVM_GET_ANSWER_ASSESSEE_FAIL";
export const SMVM_GET_ANSWER_ASSESSEE_RESET = "SMVM_GET_ANSWER_ASSESSEE_RESET";

export const SMVM_GET_LIST_ANSWER_ASSESSEE_REQUEST =
  "SMVM_GET_LIST_ANSWER_ASSESSEE_REQUEST";
export const SMVM_GET_LIST_ANSWER_ASSESSEE_SUCCESS =
  "SMVM_GET_LIST_ANSWER_ASSESSEE_SUCCESS";
export const SMVM_GET_LIST_ANSWER_ASSESSEE_FAIL =
  "SMVM_GET_LIST_ANSWER_ASSESSEE_FAIL";
export const SMVM_GET_LIST_ANSWER_ASSESSEE_RESET =
  "SMVM_GET_LIST_ANSWER_ASSESSEE_RESET";
